<template>
  <div class="con">
    <section class="print" id="pdf" ref="print">
      <div id="printTest" class="form" ref="print">
        <p class="title" style="padding-top: 30px">
          中国质量协会单位会员入会申请表
        </p>
        <p
          style="
            width: 480px;
            margin: 0 auto;
            font-size: 8px;
            color: #000;
            text-align: left;
            margin-bottom: 10px;
          "
        >
          本单位自愿加入中国质量协会，承认本会章程，在享受会员权利的同时，愿意履行会员义务和缴纳会费
        </p>
        <div class="form-wrapper">
          <div class="first-line line" style="height: auto">
            <span class="first-line-title">单位名称</span>
            <p class="border-l-r border fz6" style="word-wrap: break-word">
              {{ ruleForm.name }}
            </p>
            <span>行业类别</span>
            <p class="border border-left fz6">{{ ruleForm.sort }}</p>
          </div>

          <div class="second-line line" style="height: auto">
            <span>通讯地址</span>
            <p class="border border-l-r fz6" style="word-break: break-word">
              {{ ruleForm.addres1 }}
            </p>
            <span>职工人数</span>
            <p class="border border-left fz6">{{ ruleForm.people_num }}</p>
          </div>

          <div class="third-line line">
            <span style>单位网址</span>
            <p class="border border-l-r fz6" style="word-break: break-word">
              {{ ruleForm.addres2 }}
            </p>
            <span class="border border-right">企业性质</span>
            <p>{{ ruleForm.kind }}</p>
          </div>

          <div class="fourth-line line">
            <span>邮政编码</span>
            <p class="border border-left fz6">{{ ruleForm.youbian }}</p>
            <span class="border border-left">传真</span>
            <p class="border-left border fz6" style="word-break: break-all">
              {{ ruleForm.chuanzhen }}
            </p>
            <span class="border-left border">电话</span>
            <p class="border-left border fz6">{{ ruleForm.dianhua }}</p>
          </div>

          <div class="five-line line">
            <span>是否有母公司</span>
            <p class="border border-left fz6" style="padding: 12px 0">
              {{ ruleForm.whether }}
            </p>
            <span class="border border-left">母公司名称</span>
            <p class="border border-left fz6">{{ ruleForm.name1 }}</p>
          </div>

          <div class="six-line line">
            <span>法人代表</span>
            <p class="border border-left fz6" style="padding: 12px 0">
              {{ ruleForm.faren }}
            </p>
            <span class="border border-left">职务</span>
            <p class="border border-left fz6">{{ ruleForm.zhiwu1 }}</p>
            <span class="border border-left">电话</span>
            <p class="border border-left fz6">{{ ruleForm.dianhua1 }}</p>
          </div>

          <div class="seven-line line">
            <span>最高管理者</span>
            <p class="border border-left fz6" style="padding: 12px 0">
              {{ ruleForm.leader }}
            </p>
            <span class="border border-left">职务</span>
            <p class="border border-left fz6">{{ ruleForm.zhiwu2 }}</p>
            <span class="border border-left">电话</span>
            <p class="border border-left fz6">{{ ruleForm.dianhua2 }}</p>
          </div>

          <div class="eight-line line">
            <span>联系部门</span>
            <p class="p border border-left fz6">{{ ruleForm.bumen }}</p>
            <div class="border border-left">
              <p class="border border-bottom">负责人</p>
              <p>联系人</p>
            </div>

            <div class="border border-left">
              <p class="border border-bottom fz6">{{ ruleForm.name2 }}</p>
              <!--联系人-->
              <p class="border fz6">{{ ruleForm.name3 }}</p>
            </div>

            <div class="clearfix border border-left">
              <p class="border border-bottom">电话</p>
              <p class="border border-bottom">email</p>
              <p class="border border-bottom">手机</p>
              <p class="border border-bottom">电话</p>
              <p class="border border-bottom">email</p>
              <p>手机</p>
            </div>

            <div class="clearfix border border-left">
              <!--负责人电话-->
              <p class="border border-bottom fz6" style="padding: 0">
                {{ ruleForm.dianhua3 }}
              </p>
              <!--负责人email-->
              <p class="border border-bottom fz6" style="padding: 0">
                {{ ruleForm.email }}
              </p>
              <!--负责人手机-->
              <p
                class="border border-bottom fz6"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                {{ ruleForm.dianhua4 }}
              </p>
              <!--联系人电话-->
              <p class="border border-bottom fz6" style="padding: 0">
                {{ ruleForm.dianhua5 }}
              </p>
              <!--联系人email-->
              <p class="border border-bottom fz6" style="padding: 0">
                {{ ruleForm.email1 }}
              </p>
              <!--联系人手机-->
              <p class="fz6" style="padding: 0">{{ ruleForm.dianhua6 }}</p>
            </div>
          </div>

          <!--第九行-->
          <div class="border border-bottom" style="display: flex">
            <p
              style="width: 20px; text-align: right"
              class="float_l clearfix border border-right flex"
            >
              经营概况
            </p>
            <div class="float_l clearfix" style="width: 480px">
              <div class="line border-bottom" style="display: flex">
                <span
                  class="float_l clearfix border border-right flex"
                  style="width: 160px; padding: 3px 0"
                  >主要产品和服务</span
                >
                <p class="float_l clearfix flex fz6" style="width: 320px">
                  {{ ruleForm.product }}
                </p>
              </div>

              <!-- <div
                class="line border-bottom"
                style="height: 40px; line-height: 40px"
              >
                <span
                  class="float_l clearfix border border-right"
                  style="width: 55px; height: 40px"
                  >总资产</span
                >
                <p
                  class="float_l clearfix border border-right rap"
                  style="width: 175px; height: 40px; font-size: 6px"
                >
                  {{ ruleForm.zichan }}（万元）
                </p>
                <span
                  class="float_l clearfix border border-right"
                  style="width: 60px; font-size: 6px"
                  >销售收入</span
                >
                <p class="float_l clearfix rap fz6" style="width: 190px">
                  {{ ruleForm.shouru }}（万元）
                </p>
              </div> -->
              <div
                class="line border-bottom flex"
                style="height: 40px; line-height: 40px; width: 100%"
              >
                <span class="border-right" style="width: 55px; height: 40px"
                  >总资产</span
                >
                <p
                  class="border border-right rap"
                  style="width: 175px; height: 40px; font-size: 8px"
                >
                  {{ ruleForm.zichan }}（万元）
                </p>
                <span
                  class="border border-right"
                  style="width: 60px; font-size: 8px"
                  >销售收入</span
                >
                <p class="rap fz6" style="width: 190px; padding: 0">
                  {{ ruleForm.shouru }}（万元）
                </p>
              </div>
              <div
                class="flex"
                style="height: 40px; line-height: 40px; width: 100%"
              >
                <span class="border-right" style="width: 55px; height: 40px"
                  >总负债</span
                >
                <p
                  class="border border-right rap"
                  style="width: 175px; height: 40px; font-size: 8px"
                >
                  {{ ruleForm.fuzhai }}（万元）
                </p>
                <span
                  class="border border-right"
                  style="width: 60px; font-size: 8px"
                  >实现利税</span
                >
                <p class="rap fz6" style="width: 190px; padding: 0">
                  {{ ruleForm.lishui }}（万元）
                </p>
              </div>
              <!-- <div style="height: 40px; line-height: 40px">
                <span
                  class="float_l clearfix border border-right"
                  style="width: 55px"
                  >总负债</span
                >
                <p
                  class="float_l clearfix border border-right rap"
                  style="width: 175px; font-size: 6px"
                >
                  {{ ruleForm.fuzhai }}（万元）
                </p>
                <span
                  class="float_l clearfix border border-right"
                  style="width: 60px"
                  >实现利税</span
                >
                <p class="float_l clearfix rap fz6" style="width: 190px">
                  {{ ruleForm.lishui }}（万元）
                </p>
              </div> -->
            </div>
          </div>
          <!--第十行-->
          <div class="line border-bottom" style="display: flex">
            <span
              class="float_l clearfix border border-right flex"
              style="width: 75px"
              >企业质量<br />管理情况</span
            >
            <p
              class="float_l clearfix fz6"
              style="
                width: 425px;
                word-wrap: break-word;
                text-indent: 20px;
                white-space: pre-wrap;
                text-align: left;
                padding: 5px 10px;
                line-height: 10px;
              "
            >
              {{ ruleForm.status }}
            </p>
          </div>
          <!--第十一行-->
          <div style="display: flex">
            <span
              class="float_l clearfix border border-right flex"
              style="width: 72px"
              >对协会工作的需求及建议</span
            >
            <p
              class="float_l clearfix border border-right"
              style="
                width: 175px;
                text-indent: 20px;
                text-align: left;
                font-size: 8px;
                white-space: pre-wrap;
                padding: 5px 10px;
                line-height: 10px;
              "
            >
              {{ ruleForm.need }}
            </p>
            <span
              class="float_l clearfix border border-right flex"
              style="width: 60px; word-wrap: break-word; font-size: 8px"
              >单位意见</span
            >
            <p class="flex float_l clearfix rap" style="width: 190px">
              <br /><br />年 月 日<br />公章<br /><br />
            </p>
          </div>
        </div>
        <div
          style="
            width: 500px;
            height: 20px;
            margin: 0 auto;
            line-height: 20px;
            font-size: 8px;
          "
        >
          <span class="float_l clearfix">填表人:</span>
          <p class="float_l clearfix" style="height: 20px; margin-right: 45px">
            {{ ruleForm.tbr }}
          </p>
          <span class="float_l clearfix">填表日期:</span>
          <p class="float_l clearfix">
            {{ ruleForm.year }}年 {{ ruleForm.month }}月 {{ ruleForm.ri }}日
          </p>
          <p class="float_r clearfix" style="height: 20px">{{ ruleForm.tj }}</p>
          <span class="float_r clearfix">推荐人:</span>
        </div>
      </div>
    </section>
    <div class="btn_box" style="padding: 30px 0">
      <button class="down_load" @click="print">下载文件</button>
    </div>
  </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import Qs from 'qs'
import { setCookie, delCookie, getCookie } from '@/untils/cookie'
export default {
  data () {
    return {
      ruleForm: {
        name: '',
        sort: '',
        addres1: '',
        people_num: '',
        addres2: '',
        kind: '',
        youbian: '',
        chuanzhen: '',
        dianhua: '',
        whether: '',
        name1: '',
        faren: '',
        zhiwu1: '',
        dianhua1: '',
        leader: '',
        zhiwu2: '',
        dianhua2: '',
        bumen: '',
        name2: '',
        dianhua3: '',
        email: '',
        dianhua4: '',
        name3: '',
        dianhua5: '',
        email1: '',
        dianhua6: '',
        product: '',
        zichan: '',
        shouru: '',
        fuzhai: '',
        lishui: '',
        tbr: '',
        tj: '',
        status: '',
        need: '',
        date1: '',
        year: '',
        month: '',
        ri: '',
      },
    };
  },

  created () { },
  mounted () {
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data1 = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'society/applicationform',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 2) {
        var data = response.data.data;
        if (data.length != 0) {
          this.ruleForm.name = data.name;
          this.ruleForm.sort = data.professions;
          this.ruleForm.addres1 = data.address;
          this.ruleForm.people_num = data.number;
          this.ruleForm.addres2 = data.website;
          this.ruleForm.kind = data.company_type;
          this.ruleForm.youbian = data.postcode;
          this.ruleForm.chuanzhen = data.fax;
          this.ruleForm.dianhua = data.fax_tel;
          if (data.has_parent == '1') {
            this.ruleForm.whether = '是';
          } else {
            this.ruleForm.whether = '否';
          }
          this.ruleForm.name1 = data.parent_name;
          this.ruleForm.faren = data.corporate;
          this.ruleForm.zhiwu1 = data.corporate_title;
          this.ruleForm.dianhua1 = data.corporate_tel;
          this.ruleForm.leader = data.ceo;
          this.ruleForm.zhiwu2 = data.ceo_title;
          this.ruleForm.dianhua2 = data.ceo_tel;
          this.ruleForm.bumen = data.department;
          this.ruleForm.name2 = data.department_manager;
          this.ruleForm.fu_zhiwu = data.department_title;
          this.ruleForm.dianhua3 = data.manager_tel;
          this.ruleForm.email = data.manager_email;
          this.ruleForm.dianhua4 = data.manager_phone;
          this.ruleForm.name3 = data.user_name;
          this.ruleForm.lian_zhiwu = data.user_title;
          this.ruleForm.dianhua5 = data.user_tel;
          this.ruleForm.email1 = data.user_email;
          this.ruleForm.dianhua6 = data.user_phone;
          this.ruleForm.product = data.service;
          this.ruleForm.zichan = data.total_assets;
          this.ruleForm.shouru = data.revenue;
          this.ruleForm.fuzhai = data.total_debt;
          this.ruleForm.lishui = data.profit;
          this.ruleForm.status = data.condition;
          this.ruleForm.need = data.suggestion;
          this.ruleForm.tbr = data.username;
          this.ruleForm.tj = data.referrer;
          this.ruleForm.year = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[0];
          this.ruleForm.month = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[1];
          this.ruleForm.ri = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[2];
          this.ruleForm.s_name = data.addressee_name;
          this.ruleForm.s_dianhua = data.addressee_phone;
          this.ruleForm.s_youbian = data.addressee_zipcode;
          this.prov = data.province;
          this.city = data.city;
          this.district = data.district;
          this.ruleForm.xaddress = data.detailed_address;
        }
      }

    });
  },
  methods: {
    print () {
      this.$print(this.$refs.print);
    },
  }
}
</script>
<style scoped>
.con {
  margin: 0 auto 0;
  height: auto;
  color: #545454;
  text-align: center;
  padding-top: 20px;
}
/*表格*/

.clearfix::after {
  content: ".";
  clear: both;
  visibility: hidden;
  height: 0;
  display: block;
  line-height: 0;
}

.clearfix {
  zoom: 1;
}

.float_l {
  float: left;
}
.float_r {
  float: right;
}
.rap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fz6 {
  font-size: 8px;
  padding: 12px 0;
}

@media print {
  @page {
    size: auto; /* auto is the initial value */
    margin: 0mm; /* this affects the margin in the printer settings */
  }

  .form {
    transform-origin: 50% 0;
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
    -ms-transform: scale(1.3);
    -o-transform: scale(1.3);
    font-stretch: normal;
    margin: 0 auto;
    font-family: "宋体";
  }
}

.form {
  margin: 0 auto;
  background: #fff;
  width: 580px;
  color: #333;
  text-align: center;
  font-family: "宋体";
  padding-bottom: 20px;
}

.form .title {
  font-stretch: normal;
  margin-bottom: 8px;
  font-size: 16px;
  color: #000;
}

.form-wrapper {
  width: 500px;
  height: auto;
  margin: 0 auto;
  font-stretch: normal;
  font-size: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: #333;
  font-family: "宋体";
}

.line {
  align-items: stretch;
  box-sizing: border-box;
  border-width: 1px;
  border-color: #333;
  border-style: hidden hidden solid hidden;
}

.line p {
  /*white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;*/
}

.border-left {
  border-style: hidden hidden hidden solid;
}

.border-top {
  border-style: solid hidden hidden hidden;
}

.border-right {
  border-style: hidden solid hidden hidden;
}

.border-bottom {
  border-style: hidden hidden solid hidden;
}

.border-l-r {
  border-style: hidden solid hidden solid;
}

.border {
  border-width: 1px;
  border-color: #333;
  box-sizing: border-box;
}

.first-line,
.second-line,
.fourth-line,
.six-line {
  width: 100%;
  display: flex;
  align-items: stretch;
}

.first-line span:nth-child(1),
.second-line span:nth-child(1),
.third-line span:nth-child(1),
.fourth-line span:nth-child(1),
.six-line span:nth-child(1),
.seven-line span:nth-child(1) {
  padding: 3px 0;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-line p:nth-child(2),
.second-line p:nth-child(2) {
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-line span:nth-child(3),
.second-line span:nth-child(3),
.third-line span:nth-child(3) {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-line p:nth-child(4),
.second-line p:nth-child(4) {
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.third-line,
.five-line,
.seven-line {
  width: 100%;
  /*height: 30px;*/
  height: auto;
  display: flex;
  /*line-height: 30px;*/
  align-items: stretch;
}

.third-line p:nth-child(2) {
  width: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.third-line p:nth-child(4) {
  width: 190px;
  /*	height: 100%;*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.fourth-line p:nth-child(2) {
  width: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fourth-line span:nth-child(3) {
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fourth-line p:nth-child(4) {
  width: 70px;
  /*height: 100%;*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.fourth-line span:nth-child(5) {
  width: 60px;
  /*height: 100%;*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.fourth-line p:nth-child(6) {
  width: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.five-line {
  width: 100%;
  /*height: 30px;*/
  display: flex;
  align-items: stretch;
}

.five-line span:nth-child(1) {
  width: 109px;
  /*height: 100%;*/
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.five-line p:nth-child(2) {
  width: 70px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.five-line span:nth-child(3) {
  width: 70px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.five-line p:nth-child(4) {
  width: 250px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.six-line p:nth-child(2) {
  width: 49px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.six-line span:nth-child(3) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
}

.six-line p:nth-child(4) {
  width: 70px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.six-line span:nth-child(5) {
  width: 60px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.six-line p:nth-child(6) {
  width: 190px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seven-line p:nth-child(2) {
  width: 49px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seven-line span:nth-child(3) {
  width: 70px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seven-line p:nth-child(4) {
  width: 70px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seven-line span:nth-child(5) {
  width: 60px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seven-line p:nth-child(6) {
  width: 190px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eight-line {
  width: 100%;
  height: 155px;
  display: flex;
  /*align-items: stretch;*/
}

.eight-line span:nth-child(1) {
  float: left;
  width: 60px;
  height: 100%;
  line-height: 120px;
}

.eight-line p.p {
  display: flex;
  align-items: center;
  justify-content: center;
  /*float: left;*/
  width: 49px;
  /*height: 100%;*/
}

.eight-line div:nth-child(3) {
  float: left;
  width: 70px;
  height: 100%;
}

.eight-line div:nth-child(3) p {
  width: 100%;
  height: 76.5px;
  line-height: 76.5px;
}
.flex {
  display: flex;
}
.eight-line div:nth-child(4) {
  float: left;
  width: 70px;
  height: 100%;
}

.eight-line div:nth-child(4) p {
  width: 100%;
  height: 76.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eight-line div:nth-child(5) {
  float: left;
  width: 60px;
  height: 100%;
}

.eight-line div:nth-child(5) p,
.eight-line div:nth-child(6) p {
  height: 25.5px;
  line-height: 25.5px;
}

.eight-line div:nth-child(6) {
  float: left;
  width: 190px;
  height: 100%;
}

.eight-line div:nth-child(6) p {
  height: 25.5px;
}

.down_load {
  border: none;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  width: 166px;
  height: 40px;
  border-radius: 4px;
  background: rgba(24, 144, 255, 1);
  /*background: rgba(24, 144, 255, 1) url(../../static/img/up.png) no-repeat 13px 13px;
		background-size: 14px 14px;*/
}

.back {
  display: inline-block;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  width: 166px;
  height: 40px;
  border-radius: 4px;
  background: rgba(24, 144, 255, 1);
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Step22.vue